import { Injectable, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CustomCrudToastrService } from './custom-crud-toastr.service';

@Injectable({ providedIn: 'root' })
export class ToastService {

  constructor(
    private toast: CustomCrudToastrService,
    private injector: Injector,
  ) {}

  success(msg: string) {
    msg = this.tr(msg);
    this.toast.success(msg, '', msg, msg, { closeButton: true });
  }

  error(msg: string) {
    msg = this.tr(msg);
    this.toast.error(msg, '', msg, msg, { closeButton: true });
  }

  info(msg: string) {
    msg = this.tr(msg);
    this.toast.info(msg, '', msg, msg, { closeButton: true });
  }

  /**
   * Messages may be translation keys; any other text (e.g. from the backend) passes through unchanged.
   * TranslateService is resolved lazily: ErrorInterceptor depends on this service, and TranslateService
   * loads its JSON over HttpClient while being constructed, so injecting it eagerly creates a cycle.
   */
  private tr(msg: string): string {
    return msg ? this.injector.get(TranslateService).instant(msg) : msg;
  }
}
